/**
 * ============================================================================
 * TaskFlow ERP
 * Module : Campaign Management
 * Feature: Prospect Import
 *
 * File:
 * src/modules/campaign/prospectImport/mock/campaignCompareMock.js
 *
 * Description:
 * Mock data for Prospect Compare screen.
 * This file contains only static mock data.
 * No business logic should be implemented here.
 *
 * The service layer will consume this data.
 * Later it will be replaced by Backend APIs without changing the UI.
 * ============================================================================
 */

/**
 * --------------------------------------------------------------------------
 * Comparison Result Status
 * --------------------------------------------------------------------------
 */

export const COMPARE_RESULT = {
    MATCH: "MATCH",
    DIFFERENT: "DIFFERENT",
    MISSING: "MISSING",
    NEW: "NEW"
};

/**
 * --------------------------------------------------------------------------
 * Existing Prospect (Already available in ERP)
 * --------------------------------------------------------------------------
 */

export const existingProspectMock = {
    prospect_id: 10021,
    external_id: "EXT00002",

    company_name: "XYZ Technologies Pvt Ltd",

    campaign: "Website Leads",

    lead_source: "Website",

    industry: "Software",

    priority: "Medium",

    prospect_status: "Active",

    website: "https://www.xyztech.com",

    annual_turnover: "25 Cr",

    employee_count: 180,

    gst_number: "29ABCDE1234F1Z5",

    address: {
        line1: "22 MG Road",
        line2: "Phase 2",
        city: "Bengaluru",
        state: "Karnataka",
        country: "India",
        pincode: "560001"
    },

    contacts: [
        {
            contact_name: "Rahul Sharma",
            designation: "Purchase Manager",
            mobile: "9876543210",
            email: "rahul@xyztech.com"
        }
    ],

    tags: [
        "Manufacturing",
        "South Zone"
    ],

    remarks: "Existing Prospect"
};

/**
 * --------------------------------------------------------------------------
 * Imported Prospect
 * --------------------------------------------------------------------------
 */

export const importedProspectMock = {
    external_id: "EXT00002",

    company_name: "XYZ Technologies",

    campaign: "Website Leads",

    lead_source: "Website",

    industry: "",

    priority: "High",

    prospect_status: "Prospect",

    website: "https://xyztech.com",

    annual_turnover: "30 Cr",

    employee_count: 220,

    gst_number: "",

    address: {
        line1: "22 MG Road",
        line2: "",
        city: "Bangalore",
        state: "Karnataka",
        country: "India",
        pincode: "560001"
    },

    contacts: [
        {
            contact_name: "Rahul Sharma",
            designation: "Purchase Head",
            mobile: "9876543210",
            email: "sales@xyztech.com"
        }
    ],

    tags: [
        "Manufacturing"
    ],

    remarks: "Imported from Excel"
};

/**
 * --------------------------------------------------------------------------
 * Field Comparison
 * --------------------------------------------------------------------------
 */

export const comparisonFieldsMock = [
    {
        field: "Company Name",
        existing: "XYZ Technologies Pvt Ltd",
        imported: "XYZ Technologies",
        result: COMPARE_RESULT.DIFFERENT
    },
    {
        field: "Campaign",
        existing: "Website Leads",
        imported: "Website Leads",
        result: COMPARE_RESULT.MATCH
    },
    {
        field: "Lead Source",
        existing: "Website",
        imported: "Website",
        result: COMPARE_RESULT.MATCH
    },
    {
        field: "Industry",
        existing: "Software",
        imported: "",
        result: COMPARE_RESULT.MISSING
    },
    {
        field: "Priority",
        existing: "Medium",
        imported: "High",
        result: COMPARE_RESULT.DIFFERENT
    },
    {
        field: "Website",
        existing: "https://www.xyztech.com",
        imported: "https://xyztech.com",
        result: COMPARE_RESULT.DIFFERENT
    },
    {
        field: "Annual Turnover",
        existing: "25 Cr",
        imported: "30 Cr",
        result: COMPARE_RESULT.DIFFERENT
    },
    {
        field: "Employee Count",
        existing: 180,
        imported: 220,
        result: COMPARE_RESULT.DIFFERENT
    },
    {
        field: "GST Number",
        existing: "29ABCDE1234F1Z5",
        imported: "",
        result: COMPARE_RESULT.MISSING
    },
    {
        field: "City",
        existing: "Bengaluru",
        imported: "Bangalore",
        result: COMPARE_RESULT.DIFFERENT
    },
    {
        field: "Contact Email",
        existing: "rahul@xyztech.com",
        imported: "sales@xyztech.com",
        result: COMPARE_RESULT.DIFFERENT
    },
    {
        field: "Designation",
        existing: "Purchase Manager",
        imported: "Purchase Head",
        result: COMPARE_RESULT.DIFFERENT
    }
];

/**
 * --------------------------------------------------------------------------
 * Suggested Merge Summary
 * --------------------------------------------------------------------------
 */

export const mergeRecommendationMock = {
    duplicate_found: true,
    existing_prospect_id: 10021,

    summary: {
        matched_fields: 2,
        different_fields: 8,
        missing_fields: 2
    },

    recommendation: "Review and update existing prospect."
};

/**
 * --------------------------------------------------------------------------
 * Mock API Response
 * --------------------------------------------------------------------------
 */

export const campaignCompareMockResponse = {
    success: true,

    existing: existingProspectMock,

    imported: importedProspectMock,

    comparison: comparisonFieldsMock,

    recommendation: mergeRecommendationMock
};

export default {
    COMPARE_RESULT,
    existingProspectMock,
    importedProspectMock,
    comparisonFieldsMock,
    mergeRecommendationMock,
    campaignCompareMockResponse
};